var moduleMap = {
	"./Tile": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_ucl_react-library_breadcrumb-IToZQ6Wh_js-node_modules_ucl_react-library_-b71df3"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_ucl_shared-icons_ucl_shared-icons-webpack_sharing_consume_def-1e5573"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("webpack_sharing_consume_default_ucl_shared-component-foundations_ucl_shared-component-foundations"), __webpack_require__.e("src_Tile_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/Tile */ "./src/Tile.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});